import { FC } from 'react';
import Icon from '../../../common/icon/icon';
import Routes from '../../../constants/routes';
import translation from '../../../languages';
import cn from '../../../utils/classnames';
import './cart-header-mobile.scss';

type CartHeaderMobileProps = TranslationProps & {
    cartItems: CartItem[];
    className: string;
};

const CartHeaderMobile: FC<CartHeaderMobileProps> = ({ className = '', cartItems, t }) => {
    const handleCloseButtonClick = () => {
        if (window.history.length > 1 && cartItems.length) {
            window.history.back();
        } else {
            window.location.href = Routes.HOME.path;
        }
    };

    const count = cartItems.length || 0;

    return (
        <div className={cn('cart-header-mobile jc-start', className)}>
            <Icon name='arrow-down' width={24} height={24} animated={false} onClick={handleCloseButtonClick} />

            <span className='cart-header-title'>
                <b>{t('cart.cartItems.cart')} </b>
                {Boolean(count) && <span>{`(${count} ${t('cart.cartItems.item', { count })})`}</span>}
            </span>
        </div>
    );
};

const translate = translation('cart');

export default translate(CartHeaderMobile);
